module.exports = __webpack_public_path__ + "static/media/profile@2x.68e301a2.png";